import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ProductDetailComponent } from '../product-detail/product-detail.component';

@Component({
  selector: 'app-product-detail-modal',
  templateUrl: './product-detail-modal.component.html',
  styleUrls: ['./product-detail-modal.component.css']
})
export class ProductDetailModalComponent implements OnInit {


  @Input()  itemId : string = '';

  @ViewChild(ProductDetailComponent) productDetail: ProductDetailComponent; 
  
  constructor() { }

  ngOnInit() {
  }

  loadData(){
    this.productDetail.itemId = this.itemId;
    this.productDetail.loadData();
  }
}
